module.exports = __webpack_public_path__ + "img/1920_banner_2.c516523c.jpg";